// extracted by mini-css-extract-plugin
export default {"snippet":"styles_snippet__o+e3t"};